import produce from 'immer';

import type { PokerGameType, PokerTableType } from '@swf/generated/graphql/poker/CG/schemas';

import { defaultState } from './defaultState';
import type { PokerCashGamesState } from './types';

type State = typeof defaultState;

export const reducers = {
  clear: (): PokerCashGamesState => produce(defaultState, (draft) => draft),
  setIsLoading: (state: State, payload: boolean): State => ({
    ...state,
    isLoading: payload
  }),
  setActiveSimpleTableType: (state: State, payload: PokerTableType): State => ({
    ...state,
    simpleFilters: {
      ...state.simpleFilters,
      activeTableType: payload
    }
  }),
  setActiveSimpleGameType: (state: State, payload: PokerGameType): State => ({
    ...state,
    simpleFilters: {
      ...state.simpleFilters,
      activeGameType: payload
    }
  }),
  setActiveSliderIndex: (state: State, payload: number): State => ({
    ...state,
    simpleFilters: {
      ...state.simpleFilters,
      activeSliderIndex: payload
    }
  }),
  setQueryError: (state: State, payload: string) => ({
    ...state,
    queryError: payload,
    isLoading: false
  })
};
